export const featureContainerStyles = {
  width: "100%",
  height: 'auto',
  overflow: "hidden",
  boxSizing: "border-box",
  padding: 0,
}

export const featureCardStyles = {
  width: "100%",
  height: "auto",
  objectFit: "contain",
}